/**
 * Toaster — sonner provider, mount once in App.tsx.
 * Position bottom-right (industry-стандарт: Slack/Telegram/Bootstrap/GitHub).
 * Max 5 stack, hover-pause. Тема — light/dark через theme prop
 * (читает data-theme на html).
 */
import { Toaster as Sonner } from 'sonner'
import { useEffect, useState } from 'react'

function useResolvedTheme(): 'light' | 'dark' {
  const [theme, setTheme] = useState<'light' | 'dark'>(
    () => (document.documentElement.getAttribute('data-theme') as 'light' | 'dark') || 'light'
  )
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const t = document.documentElement.getAttribute('data-theme') as 'light' | 'dark'
      if (t === 'light' || t === 'dark') setTheme(t)
    })
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] })
    return () => observer.disconnect()
  }, [])
  return theme
}

export function Toaster() {
  const theme = useResolvedTheme()
  return (
    <Sonner
      position="bottom-right"
      visibleToasts={5}
      duration={5000}
      closeButton
      richColors
      theme={theme}
      toastOptions={{
        classNames: {
          toast:
            'rounded-lg border shadow-lg font-sans bg-surface-raised text-text-primary border-border',
          title: 'font-semibold text-sm',
          description: 'text-xs text-text-secondary',
          closeButton: 'text-text-muted hover:text-text-primary',
        },
      }}
    />
  )
}
